<template>
  <div class="modal-card" style="width: auto">
    <section class="modal-card-body">
      <button @click="$emit('close')" class="modal-close-btn" type="button">
        <span class="Reservation-title">&times;</span>
      </button>
      <div class="cont">
        <p class="text bold" style="margin-bottom: 20px; text-align: justify; color: #fff">
          Llena tus datos y haz parte de la Familia Motul, ademas recibiras una
          sorpresa increible
        </p>
        <b-field
          :message="errors.first('name')"
          :type="{ 'is-danger': errors.has('name') }"
          style="margin-bottom: 8px !important"
        >
          <b-input
            class="motul-input"
            id="name"
            name="name"
            placeholder="Nombre"
            type="text"
            v-model="data.name"
            v-validate="'required'"
          ></b-input>
        </b-field>
        <b-field
          :message="errors.first('phone')"
          :type="{ 'is-danger': errors.has('phone') }"
          style="margin-bottom: 8px !important"
        >
          <b-input
            class="motul-input"
            id="phone"
            name="phone"
            placeholder="Teléfono"
            v-model="data.phone"
            v-validate="'required|min:10|max:14|numeric'"
          ></b-input>
        </b-field>
        <b-field
          :message="errors.first('email')"
          :type="{ 'is-danger': errors.has('email') }"
          style="margin-bottom: 8px !important"
        >
          <b-input
            class="motul-input"
            id="email"
            name="email"
            placeholder="Correo"
            type="email"
            v-model="data.email"
            v-validate="'required|email'"
          ></b-input>
        </b-field>
        <div class="terms">
          <label class="checkbox__label" for="customCheckbox1">
            <div class="checkbox__group">
              <input
                class="checkbox__input"
                hidden
                id="customCheckbox1"
                name="terminos"
                type="checkbox"
                v-model="radio"
                v-validate="'required'"
              />
              <span :class="{ active: radio == true }" class="checkbox__checked"></span>
            </div>
          </label>
          <a
            class="text size-10"
            download
            href="https://api.precompro.co/docs/motul.pdf"
            style="text-decoration: underline white; color: #fff"
            target="_blank"
          >
            "Autorizo a MOTUL IBERICA S.A. SUCURSAL COLOMBIA para usar,
            transmitir, transferir y en general tratar mis datos personales
            conforme a los fines y procedimientos aplicables según la [Política
            de Tratamiento de Datos Personales].
          </a>
        </div>
        <span
          :key="'error-' + index"
          class="text size-12 red"
          style="margin-left: 20px; margin-top: 10px"
          v-for="(error, index) in errors.collect('terminos')"
        >Debe aceptar términos y condiciones</span>
        <div @click="sendForm(data)" class="btn-save">
          <span class="text black bold-strong size-18">Ingresar</span>
        </div>
      </div>
    </section>
  </div>
</template>
<script>

export default {
  data () {
    return {
      data: {
        email: '',
        phone: '',
        name: ''
      }
    };
  },
  methods: {
    sendForm (data) {
      this.$validator.validateAll().then((result) => {
        if (result === true) {
          const send = {
            name: data.name,
            email: data.email,
            phone: data.phone
          };
          this.$store
            .dispatch({ type: 'externalPrecompro:addDataPeopleMotul', send })
            .then(() => {
              this.$emit('close');
            })
            .catch((e) => {
              console.log(e);
            });
        }
      });
    }
  }
};
</script>
